function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUploadRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 26h24v-5h2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-5h2v5zm16-5v2h-8v-2h8zM16.01 3c.27 0 .54.108.738.325L24 11h-4v8h-8v-8H8l7.274-7.677A.993.993 0 0116.011 3zm-3.36 6H14v8h4V9h1.36l-3.35-3.545L12.65 9z",
    fill: props.color
  }));
}

export default SvgIconUploadRexOutline;